import {FC} from 'react';
import {shallowEqual} from 'react-redux';
import clsx from 'clsx';

import {useSelector} from '~/store/hooks';
import Header from '~/common/Header/Header';
import Loader from '~/common/Loader';
import {UserType} from '~/services/types';
import {isMobileDevice} from '~/utils/browserDetect';
import useWindowLandscape from '~/hooks/useWindowLandscape';

import Links from '../Links';
import s from './styles.module.scss';

const ProfileCard: FC<{isSnackbarVisible?: boolean}> = ({isSnackbarVisible}) => {
  const isLandscape = useWindowLandscape();
  const {loading, data, isMenuLocked} = useSelector(
    (state) => ({
      loading: !!state.loading.effects.profile.getCurrentUserInfo.loading,
      data: state.profile.data,
      isMenuLocked: state.app.isMenuLocked,
    }),
    shallowEqual
  );

  // Hack!!!
  const handleClose = () => {
    document.dispatchEvent(new Event('click'));
  };

  if (loading || !data) {
    return (
      <div className={clsx(s.wrapper, s.wrapper__loading)}>
        <Loader />
      </div>
    );
  }

  return (
    <div
      className={clsx(s.wrapper, {
        [s['wrapper--shifted']]: isSnackbarVisible,
        [s['wrapper--landscape']]: isLandscape && isMobileDevice(),
      })}
    >
      <Header
        className={s.header}
        badgesClassName={s.header__badges}
        firstName={data.firstName}
        lastName={data.lastName}
        location={data.location}
        balance={data.balance}
        avatar={data.avatar}
        onClose={handleClose}
        showAds={data.isAdvertiser}
        showBalance={data.userType !== UserType.Regular}
        isMenuLocked={isMenuLocked}
        count={{ads: data.liveAds, reviews: data.reviews, favorites: 0, questions: data.questions}}
      />
      <div className={s.content}>
        <Links isMenuLocked={isMenuLocked} />
      </div>
    </div>
  );
};

export default ProfileCard;
